import ModalLoadingOverlay from '@/components/_common/ModalLoadingOverlay';
import { useWorkOrderItems } from '@/core/domain/workorder/WorkOrdersItems/WorkOrdersItems.hooks';
import { forwardRef, useImperativeHandle } from 'react';
import { hasWorkOrderItemsIntegrationInvalid } from '../../../PecaAi/BasketItemsIntegrationVerification';
import { Button } from 'antd';
import { useHistory } from 'react-router-dom';

interface Props {
  workOrderId: number;
  complementId: number;
  onClose?: VoidFunction;
}

export interface ComplementVerifyPartIntegrationRef {
  hasInvalid: boolean;
}

const ComplementVerifyPartIntegration = forwardRef<
  ComplementVerifyPartIntegrationRef,
  Props
>((props, ref) => {
  const workOrderItems = useWorkOrderItems(
    props.complementId,
    false,
    undefined,
    false,
  );

  const history = useHistory();

  const hasInvalid = hasWorkOrderItemsIntegrationInvalid(
    workOrderItems.data?.data,
  );

  useImperativeHandle(
    ref,
    () => ({
      hasInvalid: hasWorkOrderItemsIntegrationInvalid(
        workOrderItems.data?.data,
      ),
    }),
    [workOrderItems.dataUpdatedAt, workOrderItems.isLoading],
  );

  if (!hasInvalid) return null;

  return (
    <ModalLoadingOverlay
      posAbsolute
      disableLoading
      messages={[
        <div style={{ textAlign: 'center' }}>
          <div>Há peças de integração sem vínculo com o estoque</div>
          <Button
            onClick={() => {
              if (props.onClose) {
                props.onClose();
              }

              history.push(
                `/app/movements/workOrders/${props.workOrderId}/complements/${props.complementId}/partsAndTasks#items-verification`,
              );
            }}
            style={{ marginTop: 16 }}
          >
            Atualizar itens
          </Button>
        </div>,
      ]}
      style={{ overflow: 'hidden', borderRadius: 8 }}
    />
  );
});

ComplementVerifyPartIntegration.displayName = 'ComplementVerifyPecaAi';

export default ComplementVerifyPartIntegration;
